/* eslint-disable consistent-return */
import React, { useState, useEffect, useRef } from 'react';

import { useLocation } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

import { useQuery } from '@tanstack/react-query';
import moment from 'moment';
import SinglePost from './SinglePost';
import Feed from './Feed';
import AddContent from './AddContent';
import UsersOnline from './UsersOnline';
// import ProductAnnouncements from './ProductAnnouncements';
// import Ads from './Ads';
import RecentlyActivities from './RecentlyActivities';
import UpcomingEvents from '../Dashboard/RightPanel/UpcomingEvents';
import TwoWeeksCalendar from '../Dashboard/RightPanel/TwoWeeksCalendar';
import { useFeedStore } from '../../../store';
import { ensureDragDropTouchLoaded } from '../../../helpers/loadDragDropTouch';
import classes from './styles.module.scss';
import CalendarService from '../../../services/CalendarService';
import { getEvents } from '../../../helpers/getEvents';
import UserService from '../../../services/UserService';
import { getAuthData } from '../../../helpers/authStorage';
// import LatestNotifications from '../Dashboard/RightPanel/LatestNotifications';

const today = moment();

export default function Discover() {
  const [isEditorVisible, setIsEditorVisible] = useState(false);
  const [editingPost, setEditingPost] = useState(null);
  const { userId } = getAuthData();
  const leftColRef = useRef();

  const location = useLocation();

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });

  const setSharedClasses = useFeedStore((state) => state.setSharedClasses);

  const { data: calendarEvents } = useQuery({
    queryKey: ['calendarEvents'],
    queryFn: CalendarService.getEvents,
  });

  const { data: user } = useQuery({
    queryKey: ['me'],
    queryFn: UserService.getMe,
  });

  const events = getEvents(
    calendarEvents,
    +userId,
    null,
    user?.userProfile?.timezone
  );
  useEffect(() => {
    setSharedClasses(classes);
  }, [setSharedClasses]);

  // add script to handle drag and drop on mobile devices
  useEffect(() => {
    ensureDragDropTouchLoaded().catch(() => {});
  }, []);

  const rightCol = (
    <div className={classes.rightCol}>
      <UsersOnline />
      <div className={classes.calendarContainer}>
        <TwoWeeksCalendar
          today={today}
          events={events.filter(
            (event) =>
              event.status !== 'Declined' && event.status !== 'Canceled'
          )}
        />
      </div>

      {/* <ProductAnnouncements />
      <Ads /> */}
      <UpcomingEvents
        today={today}
        events={events.filter(
          (event) => event.status !== 'Declined' && event.status !== 'Canceled'
        )}
      />
      {/* <LatestNotifications /> */}
    </div>
  );

  return (
    <div className={classes.Discover}>
      {location.pathname.includes('tools/discover/posts/') ? (
        <div className={classes.leftCol}>
          <div className={classes.leftColContainer} id="dicoveryLeftCol">
            <SinglePost setEditingPost={setEditingPost} />
          </div>
        </div>
      ) : (
        <>
          {isTabletOrMobile && (
            <>
              <RecentlyActivities />
              {rightCol}
            </>
          )}
          <div
            className={classes.leftCol}
            ref={leftColRef}
            id="dicoveryLeftCol"
          >
            <div className={classes.leftColContainer}>
              {!isTabletOrMobile && <RecentlyActivities />}
              <AddContent
                setIsEditorVisible={setIsEditorVisible}
                isEditorVisible={isEditorVisible}
                sharedClasses={classes}
                editingPost={editingPost}
                setEditingPost={setEditingPost}
              />
            </div>
            <Feed setEditingPost={setEditingPost} leftColRef={leftColRef} />
          </div>
        </>
      )}
      {!isTabletOrMobile && rightCol}
    </div>
  );
}
